/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ContractRubricSummary } from './ContractRubricSummary';
import {
    ContractRubricSummaryFromJSON,
    ContractRubricSummaryFromJSONTyped,
    ContractRubricSummaryToJSON,
} from './ContractRubricSummary';

/**
 * 
 * @export
 * @interface ContractSummary
 */
export interface ContractSummary {
    /**
     * 
     * @type {string}
     * @memberof ContractSummary
     */
    subtype: ContractSummarySubtypeEnum;
    /**
     * 
     * @type {Array<ContractRubricSummary>}
     * @memberof ContractSummary
     */
    rubrics: Array<ContractRubricSummary>;
}


/**
 * @export
 */
export const ContractSummarySubtypeEnum = {
    Tiers: 'tiers',
    Categories: 'categories'
} as const;
export type ContractSummarySubtypeEnum = typeof ContractSummarySubtypeEnum[keyof typeof ContractSummarySubtypeEnum];


/**
 * Check if a given object implements the ContractSummary interface.
 */
export function instanceOfContractSummary(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "subtype" in value;
    isInstance = isInstance && "rubrics" in value;

    return isInstance;
}

export function ContractSummaryFromJSON(json: any): ContractSummary {
    return ContractSummaryFromJSONTyped(json, false);
}

export function ContractSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractSummary {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'subtype': json['subtype'],
        'rubrics': ((json['rubrics'] as Array<any>).map(ContractRubricSummaryFromJSON)),
    };
}

export function ContractSummaryToJSON(value?: ContractSummary | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'subtype': value.subtype,
        'rubrics': ((value.rubrics as Array<any>).map(ContractRubricSummaryToJSON)),
    };
}

